
(() => {
  // app/scripts/component/cartRemove.js
  window.customElements.define("cart-remove", class extends HTMLButtonElement {
    constructor() {
      super();
      this.addEventListener("click", this.onClick.bind(this));
    }
    async onClick() {
      const response = await fetch(`${this.dataset.url}.js`, {
        credentials: "same-origin",
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        }
      });
      const cartContent = await response.json();
      document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
        bubbles: true,
        detail: {
          cart: cartContent
        }
      }));
      document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
        bubbles: true,
        detail: {
          cart: cartContent
        }
      }));
    }
  }, { extends: "button" });

  // app/scripts/function/cookie.js
  var cookie = {
    get: function(key) {
      var keyValue = document.cookie.match("(^|;) ?" + key + "=([^;]*)(;|$)");
      return keyValue ? JSON.parse(keyValue[2]) : null;
    },
    set: function(key, value, expiry) {
      var expires = /* @__PURE__ */ new Date();
      expires.setTime(expires.getTime() + expiry * 24 * 60 * 60 * 1e3);
      document.cookie = key + "=" + JSON.stringify(value) + ";expires=" + expires.toUTCString() + ";path=/";
    },
    delete: function(key) {
      var keyValue = this.get(key);
      this.set(key, keyValue, "-1");
    }
  };

  // app/scripts/function/ymmUtils.js
  var API = `/apps/ymm-1/api/elastic/products-boost-auto-parts/_search`;
  var FITMENT_TABLE_API = `/apps/ymm-1/api/elastic/products-boost-auto-parts/_doc`;
  function ymmAPI(body) {
    return new Promise((resolve, reject) => {
      fetch(API, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body)
      }).then((res) => res.json()).then((res) => resolve(res)).catch((error) => reject(error));
    });
  }

  /**
   * Determine whether results are empty.
   * True when only Universal fitment items are in the response.
   * @param {Array} products - Products from YMM API response.
   * @returns {Boolean}
   */
  function isEmpty(products) {
    const container = document.querySelector('ymm-filter-component');
    const { enableAllUniversal } = container?.dataset;
    const totalLength = products.length;

    if (totalLength > 0 && enableAllUniversal) {
      return false;
    }

    const allUniversal = !products.some(product => {
      return !product?._source?.metafields?.ymma_fitment?.value.includes('Universal');
    });

    return allUniversal;
  }

  async function getFitmentTableData(productID) {
    if (this.cachedFitmentTableData) {
      return Promise.resolve(this.cachedFitmentTableData);
    }
    const fitmentTableData = await new Promise((resolve, reject) => {
      fetch(FITMENT_TABLE_API + "/" + productID).then((res) => res.json()).then((res) => resolve(res)).catch((error) => reject(error));
    });
    this.cachedFitmentTableData = fitmentTableData;
    return fitmentTableData;
  }
  function saveYMMSelectorValues(array) {
    array.forEach((select) => {
      const name = select.getAttribute("name");
      const key = `ymm-${name}`;
      const value = String(select.value);
      localStorage.setItem(key, value);
    });
  }
  function resetYMMValueInLocalStorage(array) {
    array.forEach((select) => {
      const name = select.getAttribute("name");
      const key = `ymm-${name}`;
      const value = "";
      localStorage.setItem(key, value);
    });
  }
  function getYMMValue() {
    const must = [];
    const ymmSelector = document.querySelector("ymm-selector");
    ymmSelector.querySelectorAll(".jsYMMSelect").forEach((item) => {
      item.value != "" && must.push({
        "match": {
          [`ymms.${item.name}`]: item.value
        }
      });
    });
    return must.length ? {
      "nested": {
        "path": "ymms",
        "query": {
          "bool": {
            must
          }
        }
      }
    } : null;
  }
  function hasYMMData() {
    const year = localStorage.getItem("ymm-year") || "";
    const make = localStorage.getItem("ymm-make") || "";
    const model = localStorage.getItem("ymm-model") || "";
    return year.length > 0 || make.length > 0 || model.length > 0;
  }
  function getSortQuery() {
    const sortElment = document.querySelector('input[name="ymm_sort"]:checked');
    if (!sortElment) {
      return void 0;
    }
    let order;
    if (sortElment.value.includes("ascending"))
      order = "asc";
    else
      order = "desc";
    return [
      {
        "variants.price": {
          "mode": "avg",
          order,
          "nested": {
            "path": "variants"
          }
        }
      }
    ];
  }
  function ymmFilterParams() {
    const params = [];
    let hasPrice = false;
    document.querySelectorAll(".jsYMMParams").forEach((item) => {
      if (item.type == "checkbox" && item.checked) {
        params.push({
          "match": {
            [item.dataset.ymm]: item.value
          }
        });
      } else if (item.classList.contains("jsYMMPrice") && !hasPrice) {
        hasPrice = true;
        const object = {};
        document.querySelectorAll(".jsYMMPrice").forEach((item2) => {
          object[item2.dataset.ymm] = +item2.value;
        });
        params.push({
          "nested": {
            "path": "variants",
            "query": {
              "bool": {
                "must": [
                  {
                    "range": {
                      "variants.price": object
                    }
                  }
                ]
              }
            }
          }
        });
      }
    });
    return params;
  }
  function ymmFilter() {
    let must = [];
    const ymmValue = getYMMValue.call(this);
    const { size, page } = this.dataset;
    const from = (page || 0) * (size || 25);
    const params = ymmFilterParams.call(this);
    const sortParms = getSortQuery();
    let sort = void 0;
    ymmValue && must.push(ymmValue);
    if (params.length)
      must = must.concat(params);
    if (sortParms)
      sort = { sort: sortParms };
    return {
      "_source": {
        "exclude": [
          "ymms.*"
        ]
      },
      from,
      size,
      "query": {
        "bool": {
          must
        }
      },
      ...sort
    };
  }
  function getYMMSelectorQueries(param = "year", selectors = []) {
    const terms = !selectors.length ? [] : selectors.map((item) => {
      return item.value && {
        "term": {
          [`ymms.${item.name}`]: item.value
        }
      };
    });
    let query = {
      "size": 0,
      "query": {
        "nested": {
          "path": "ymms",
          "query": {
            "bool": {
              "must": terms
            }
          }
        }
      },
      "aggs": {
        "ymms": {
          "nested": {
            "path": "ymms"
          },
          "aggs": {
            "model_terms": {
              "filter": {
                "bool": {
                  "must": terms
                }
              },
              "aggs": {
                "models": {
                  "composite": {
                    "size": 1e3,
                    "sources": [
                      {
                        "model": {
                          "terms": {
                            "field": `ymms.${param}`
                          }
                        }
                      }
                    ]
                  }
                }
              }
            }
          }
        }
      }
    };
    return query;
  }
  function setYMMSelectorValue(resp) {
    const fieldName = this.name;
    const data = resp.ymms.model_terms.models;
    const { buckets } = data;
    const selectedValue = localStorage.getItem(`ymm-${fieldName}`);
    const initOption = `<option value="">${fieldName.toUpperCase()}</option>`;
    const options = buckets.map((b) => {
      const value2 = b.key.model;
      return `<option value="${value2}"${String(b.key) === selectedValue ? " selected" : ""}>${value2}</option>`;
    });
    const html = [initOption, ...options].join("");
    for (const select of document.querySelectorAll(`.ymm-${fieldName}-select`)) {
      select.innerHTML = html;
      select.removeAttribute("disabled");
    }
  }
  function loadYMMFromCache(array) {
    let str = [];
    for (const field of array) {
      const value = localStorage.getItem(`ymm-${field}`);
      if (value == null || value.trim() === "")
        continue;
      str.push(value);
      document.querySelectorAll(`.ymm-${field}-select`).forEach((select) => {
        select.value = value;
        if (!select.value) {
          const option = document.createElement("option");
          option.value = value;
          option.innerHTML = value;
          select.appendChild(option);
          select.value = value;
        }
      });
    }
    return str.join(" ");
  }
  function getYMMURLParams(array) {
    const params = array.map((key) => {
      const value = localStorage.getItem(`ymm-${key}`);
      if (value == null || value.trim() === "")
        return "";
      return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
    });
    let paramsURL = params.filter((u) => u.length);
    return paramsURL.length ? `?${paramsURL.join("&")}` : "";
  }
  function getYMMParamsFromURL(array) {
    let queryString = new URLSearchParams(location.search);
    const nameList = ["year", "make", "model"];
    for (let pair of queryString.entries()) {
      const name = pair[0];
      if (nameList.includes(name)) {
        const key = `ymm-${name}`;
        const value = pair[1];
        localStorage.setItem(key, value);
      }
    }
  }

  // app/scripts/component/ymmSelector.js
  document.body.addEventListener("click", function(e) {
    if (window.matchMedia("(max-width: 991px)").matches) {
      const header_ymm_selector = document.querySelector('ymm-selector[data-section="header"]');
      if (header_ymm_selector.classList.contains("tooltip-active") && !e.target.closest('ymm-selector[data-section="header"]')) {
        header_ymm_selector.classList.remove("tooltip-active");
      }
    }
    if (!e.target.closest("ymm-selector") && document.querySelector("ymm-selector details[open]")) {
      document.querySelector("ymm-selector details[open]").open = false;
    }
    if (e.target.closest(".jsYMMBtn") && document.getElementById("ymmSelector")) {
      document.getElementById("ymmSelector").focus();
      document.getElementById("ymmSelector").open = true;
      document.getElementById("ymmSelector").closest(".tooltip-active")?.classList.remove("tooltip-active");
    }
  });
  document.documentElement.addEventListener("ymm:filter:loaded", () => {
    document.getElementById("ymmSelector").setAttribute("data-state", "select");
  });
  customElements.define("ymm-selector", class extends HTMLElement {
    constructor() {
      super();
      this.setDefault();
      this.showToolTip();
      this.hasAttribute("auto-fetch") && this.initialize(true);
      this.addEventListener("change", this.onChange.bind(this));
      this.addEventListener("mouseleave", () => {
        this.classList.remove("tooltip-active");
      }, { once: true });
      this.addEventListener("click", (e) => {
        if (e.target.closest(".jsYMMSubmit"))
          this.submit(e);
        if (e.target.closest(".jsYMMSave"))
          this.save(e);
        if (e.target.closest(".jsYMMReset"))
          this.reset(e);
        if (e.target.closest(".close-tooltip"))
          this.classList.remove("tooltip-active");
      });
      this.closest(".header") && document.addEventListener("click", (e) => {
        if (e.target.closest(".jsYMMViewAll"))
          this.submit(e);
      });
    }
    setDefault() {
      this.page = 0;
      this.size = +this.dataset.size || 25;
      this.ymmSelectors = [...this.querySelectorAll(".jsYMMSelect")];
      this.paramsList = this.ymmSelectors.map((item) => item.name);
      getYMMParamsFromURL(this.paramsList);
      document.addEventListener("ymm", (e) => {
        for (const select of document.querySelectorAll(`.ymm-${e.name}-select`)) {
          select.value = e.value;
        }
      });
      !loadYMMFromCache(this.paramsList) && this.closest("#ymmPopup") && window.addEventListener("DOMContentLoaded", () => {
        this.closest("#ymmPopup").open = true;
      });
    }
    async initialize() {
      const { aggregations } = await ymmAPI(getYMMSelectorQueries(this.paramsList[0]));
      setYMMSelectorValue.call(this.ymmSelectors[0], aggregations);
      this.setVehicleValue();
      this.updateURL();
      document.dispatchEvent(new CustomEvent("ymmData:Loaded"));
    }
    async onChange({ target: currentTarget }) {
      const currentSelector = currentTarget.closest("select");
      const index = this.ymmSelectors.indexOf(currentSelector) + 1;
      this.resetAllNextSelectors(index);
      const selectedSelectors = this.ymmSelectors.filter((select) => select.value);
      const nextSelector = this.ymmSelectors[index];
      this.toggleSubmitButtonAttribute = this.isSelectorValid();
      if (!nextSelector || !currentSelector.value.length) {
        return;
      }
      const { aggregations } = await ymmAPI(getYMMSelectorQueries(nextSelector.name, selectedSelectors));
      setYMMSelectorValue.call(nextSelector, aggregations);
    }
    resetAllNextSelectors(i) {
      document.querySelectorAll("ymm-selector").forEach((selector) => {
        let ymmSelectors = selector.ymmSelectors;
        for (let index = i; index < ymmSelectors.length; index++) {
          let select = ymmSelectors[index];
          select.innerHTML = `<option value>${select.dataset.placeholder || select.name.toUpperCase()}</option>`;
          select.setAttribute("disabled", "disabled");
        }
      });
    }
    set toggleSubmitButtonAttribute(value) {
      document.querySelectorAll(".vehicle__submit:not(.vehicle__reset) button").forEach((button) => {
        button.toggleAttribute("disabled", value);
      });
    }
    onSelected() {
      document.dispatchEvent(new CustomEvent("ymmData:Changed"));
      window.dispatchEvent(new CustomEvent("ymm:filter"));
      if (window.location.href.includes("/collections")) {
        const facetMain = document.querySelector("#facet-main");
        facetMain.scrollIntoView();
      }
    }
    submit(event) {
      this.save(event);
      if (this.closest("ymm-filter-component, ymm-filter-section")) {
        return;
      }
      location.href = this.dataset.url + getYMMURLParams(this.paramsList);
    }
    save(event) {
      event.preventDefault();
      saveYMMSelectorValues(this.ymmSelectors);
      this.updateURL();
      this.setVehicleValue();
      if (event.target.closest("#ymmSelector")) {
        event.target.closest("#ymmSelector").removeAttribute("open");
        this.showToolTip("save");
      }
      this.onSelected();
    }
    reset(event) {
      event.preventDefault();
      resetYMMValueInLocalStorage(this.ymmSelectors);
      this.resetAllNextSelectors(0);
      this.initialize();
      this.updateURL();
      this.onSelected();
      let homeFilterSection = document.querySelector("ymm-selector[auto-filter]");
      if (!homeFilterSection)
        return;
      homeFilterSection.callFilter();
    }
    set open(bool) {
      const details = this.querySelector("details");
      if (!details)
        return;
      details.open = bool;
    }
    showToolTip(type = "tutorial") {
      if (!this.querySelector("details"))
        return;
      const cookie_key = type == "tutorial" ? "disabled__tooltip__tutorial" : "disabled__tooltip__save";
      if (!cookie.get(cookie_key) || type == "tutorial" && hasYMMData() && !cookie.get("disabled__tooltip__returning")) {
        this.classList.add("tooltip-active");
        if (!cookie.get(cookie_key)) {
          cookie.set(cookie_key, true, 3);
        } else {
          cookie.set("disabled__tooltip__returning", true, 3);
        }
        const isCloseMaually = document.querySelector("ymm-selector").dataset.ismanually;
        if (!isCloseMaually) {
          if (this.toolTipShow != null)
            clearTimeout(this.toolTipShow);
          this.toolTipShow = setTimeout(() => {
            this.classList.remove("tooltip-active");
            this.toolTipShow = null;
          }, 3e3);
        }
      }
    }
    setVehicleValue() {
      let str = loadYMMFromCache(this.paramsList);
      async function setFitNote() {
        if (!window.theme.product)
          return;
        const result = await getFitmentTableData(window.theme.product.id);
        const fitmentTable = result?._source?.ymms;
        if (str.length) {
          let fitSelected = str;
          fitSelected = fitSelected.split(" ").join("-");
          fitSelected = fitSelected.toLowerCase();
          fitmentTable?.forEach((fitItem) => {
            let vehicleFitment = `${fitItem.year} ${fitItem.make} ${fitItem.model}`;
            vehicleFitment = vehicleFitment.split(" ").join("-");
            vehicleFitment = vehicleFitment.toLowerCase();
            if (fitSelected == vehicleFitment) {
              if (fitItem.note) {
                document.querySelectorAll(".jsFitNote").forEach((item) => {
                  item.innerHTML = `Note: ${fitItem.note}`;
                  item.style.display = "block";
                });
              } else {
                document.querySelectorAll(".jsFitNote").forEach((item) => {
                  item.innerHTML = "";
                  item.style.display = "none";
                });
              }
            }
          });
        } else {
          document.querySelectorAll(".jsFitNote").forEach((item) => {
            item.innerHTML = "";
            item.style.display = "none";
          });
        }
      }
      setFitNote();
      if (str.length) {
        this.toggleSubmitButtonAttribute = this.isSelectorValid();
        document.querySelectorAll(".jsFitValue").forEach((item) => {
          if (item.closest("ymm-fitment")) {
            item.closest("ymm-fitment").style.opacity = 0;
          }
          item.innerHTML = str;
        });
        document.querySelectorAll("ymm-selector").forEach((selector) => selector.classList.add("submitted"));
        this.querySelector("#ymmSelector")?.setAttribute("data-state", "select");
      } else {
        document.querySelectorAll(".jsFitValue").forEach((item) => {
          if (item.closest("ymm-fitment")) {
            item.closest("ymm-fitment").style.opacity = 0;
          }
          item.innerHTML = "";
        });
        this.querySelector("#ymmSelector")?.setAttribute("data-state", "unselect");
        document.querySelectorAll("ymm-selector").forEach((selector) => selector.classList.remove("submitted"));
      }
    }
    updateURL() {
      let searchArr = [];
      let newUrl = window.location.origin + window.location.pathname;
      let ymmParams = getYMMURLParams(this.paramsList);
      let queryString = new URLSearchParams(location.search);
      for (let pair of queryString.entries()) {
        const [name, value] = pair;
        !this.paramsList.includes(name) && searchArr.push(pair.join("="));
      }
      if (searchArr.length) {
        newUrl += "?" + searchArr.join("&");
        if (ymmParams.length)
          ymmParams = "&" + ymmParams.slice(1);
      }
      newUrl += ymmParams;
      window.history.replaceState({ path: newUrl }, "", newUrl);
    }
    isSelectorValid() {
      return !this.ymmSelectors.every((i) => i.value.length);
    }
  });
  customElements.define("ymm-fitment", class extends HTMLElement {
    constructor() {
      super();
      const callback = async () => {
        const matchYMM = {};
        const ymmSelector = document.querySelector("ymm-selector");
        ymmSelector.querySelectorAll(".jsYMMSelect").forEach((item) => {
          if (item.value === "") return;
          matchYMM[item.name] = item.value;
        });

        const docResult = await getFitmentTableData(window.theme.product.id);
        const foundYMM = docResult?._source?.ymms?.find(ymm => {
          for (const [key, value] of Object.entries(matchYMM)) {
            if (ymm[key] !== value) return false;
          }
          return true;
        });

        this.setFitment = foundYMM;
        this.style.opacity = 1;
      };
      document.addEventListener("ymmData:Loaded", callback.bind(this));
      document.addEventListener("ymmData:Changed", callback.bind(this));
    }
    set setFitment(value) {
      let hasYMM = hasYMMData();
      if (!hasYMM) {
        this.setAttribute("data-state", "");
      } else {
        this.setAttribute("data-state", value ? "fitted" : "nofit");
      }
    }
  });
  customElements.define("fitment-table", class extends HTMLElement {
    constructor() {
      super();
      window.theme.product && this.fetchFitmentData();
    }
    async fetchFitmentData() {
      const result = await getFitmentTableData(window.theme.product.id);
      const tableItems = result?._source?.ymms;
      const tableBodyElement = this.querySelector("table tbody");
      if (!tableItems)
        return;
      tableItems.sort((a, b) => {
        return b.year - a.year;
      });
      tableItems.forEach((item) => {
        const tr = this.querySelector("table thead tr").cloneNode(true);
        tr.querySelector("td:first-child").innerHTML = `${item.year} ${item.make} ${item.model}`;
        tr.querySelector("td:last-child").innerHTML = item.note;
        tableBodyElement.insertAdjacentElement("beforeend", tr);
      });
    }
  });

  // app/scripts/function/ymmUtilsTeifi.js
  window.ymmOptions = {
    appName: "ymm-1",
      shopName: "boost-auto-parts",
      firstLoad: true
  };
  function floatEqual(a, b) {
    return Math.abs(parseInt(a) - parseInt(b)) < 1e-3;
  }
  function getSortQuery2(container) {
    const sortElement = document.querySelector('[name="ymm_sort"]:checked');
    if (!sortElement)
      return void 0;
    const type = sortElement.value;
    const order = type.includes("descending") ? "desc" : "asc";
    const collectionId = container?.dataset?.collectionId?.trim();
    if (type.includes("price")) {
      return [
        {
          "variants.price": {
            mode: "min",
            order,
            nested: {
              path: "variants"
            }
          }
        }
      ];
    } else if (type.includes("title")) {
      return { title: { order } };
    } else if (type.includes("created")) {
      return { createdAt: { order } };
    } else if (type.includes("manual") && collectionId != null && collectionId !== "") {
      return {
        "collections.sort": {
          order,
          nested: {
            path: "collections",
            filter: {
              term: {
                "collections.id": collectionId
              }
            }
          }
        }
      };
    }
    return void 0;
  }
  function getYMMFilters() {
    const variantsSelectedOptions = {};
    const variantsPrice = {};
    const fitments = [];
    const productTypes = [];
    for (const el of document.querySelectorAll(".jsYMMParams")) {
      const { filterType, filterOptionName } = el.closest("[data-filter-type]").dataset;
      if (filterType === "variant_option") {
        if (el.type !== "checkbox" || !el.checked)
          continue;
        addSelectedOptions(filterOptionName, el.value);
      } else if (filterType === "variant_price") {
        const { name, value } = el;
        let n = void 0;
        if (value.trim() !== "") {
          const v = Number(value);
          const bound = Number(name === "gte" ? el.getAttribute("min") : el.getAttribute("max"));
          if (!floatEqual(v, bound)) {
            n = v;
          }
        }
        variantsPrice[el.name] = n;
      } else if (filterType === "fitment") {
        if (!el.checked)
          continue;
      } else if (filterType === "product_type") {
        if (!el.checked)
          continue;
        productTypes.push(el.value);
      } else {
        console.error("Unhandled filter element", el);
      }
    }
    if (Object.keys(YMM.getYMMValue()).length) {
      fitments.push("Vehicle Specific");
      fitments.push("Universal");
    }
    return { variantsSelectedOptions, variantsPrice, fitments, productTypes };
    function addSelectedOptions(key, value) {
      const selectedOptions = variantsSelectedOptions[key] ?? [];
      if (!selectedOptions.includes(value)) {
        selectedOptions.push(value);
      }
      variantsSelectedOptions[key] = selectedOptions;
    }
  }
  function getSizedMediaUrl(media, size) {
    let src = typeof media === "string" ? media : media["preview_image"] ? media["preview_image"]["src"] : media["url"];
    if (size === null) {
      return src;
    }
    if (size === "master") {
      return src.replace(/http(s)?:/, "");
    }
    const match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif|webp)(\?v=\d+)?$/i);
    if (match) {
      const prefix = src.split(match[0]);
      const suffix = match[0];
      return (prefix[0] + "_" + size + suffix).replace(/http(s)?:/, "");
    } else {
      return null;
    }
  }
  var YMM = {
    ymmAPI: (body) => {
      return new Promise((resolve, reject) => {
        fetch(`/apps/${ymmOptions.appName}/api/elastic/products-${ymmOptions.shopName}/_search`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(body)
        }).then((res) => res.json()).then((res) => resolve(res)).catch((error) => reject(error));
      });
    },
    getYMMValue: () => {
      const ymm = {};
      for (const name of ["year", "make", "model"]) {
        const value = localStorage.getItem(`ymm-${name}`);
        if (value == null || value.trim() === "")
          continue;
        ymm[name] = value;
      }
      return ymm;
    },
    ymmSave: () => {
      (void 0).querySelectorAll("select").forEach((select) => {
        const name2 = select.getAttribute("name");
        const key2 = `ymm-${name2}`;
        const value2 = String(select.value);
        localStorage.setItem(key2, value2);
      });
    },
    ymmFilter: (container, aggOptions = null) => {
      const ymmValue = YMM.getYMMValue();
      container.lastQuery = JSON.stringify(ymmValue);
      const { size, page } = container;
      const from = (page || 0) * (size || 24);
      const filters = getYMMFilters();
      const sort = getSortQuery2(container);
      const should = [];
      const must = [];
      const isSelectingYMM = aggOptions?.nextYMMName != null;
      if (isSelectingYMM || filters.fitments.includes("Vehicle Specific")) {
        const ymmMust = [];
        for (const key of ["year", "make", "model"]) {
          if (aggOptions?.nextYMMName === key)
            break;
          const value = ymmValue[key];
          if (value != null && value.trim() !== "") {
            ymmMust.push({ match: { [`ymms.${key}`]: value } });
          }
        }
        if (ymmMust.length > 0) {
          should.push({
            nested: {
              path: "ymms",
              query: {
                bool: {
                  must: ymmMust
                }
              }
            }
          });
        }
      }
      if (!isSelectingYMM) {
        if (filters.fitments.includes("Universal")) {
          should.push({
            nested: {
              path: "metafields.ymma_fitment",
              query: {
                bool: {
                  must: [
                    { match: { "metafields.ymma_fitment.value": "Universal" } }
                  ]
                }
              }
            }
          });
        }
        const collectionId = container?.dataset?.collectionId;
        if (collectionId != null && collectionId.trim() !== "") {
          must.push({
            nested: {
              path: "collections",
              query: {
                bool: {
                  must: [
                    { match: { "collections.id": container.dataset.collectionId } }
                  ]
                }
              }
            }
          });
        }
        for (const [optionName, optionValues] of Object.entries(filters.variantsSelectedOptions)) {
          must.push({
            nested: {
              path: "variants.selectedOptions",
              query: {
                bool: {
                  must: [
                    { term: { "variants.selectedOptions.name": optionName } },
                    { terms: { "variants.selectedOptions.value": optionValues } }
                  ]
                }
              }
            }
          });
        }
        if (filters.variantsPrice?.lte != null || filters.variantsPrice?.gte != null) {
          must.push({
            nested: {
              path: "variants",
              query: {
                bool: {
                  must: [
                    { range: { "variants.price": filters.variantsPrice } }
                  ]
                }
              }
            }
          });
        }
        if (filters.productTypes.length > 0) {
          must.push({
            terms: { productType: filters.productTypes }
          });
        }
      }
      const query = {
        bool: {
          should,
          minimum_should_match: should.length === 0 ? void 0 : 1,
          must
        }
      };
      const aggs = {};
      if (aggOptions?.include) {
        aggs["variants"] = {
          nested: {
            path: "variants"
          },
          aggs: {
            available_ranges: {
              range: {
                field: "variants.inventoryQuantity",
                ranges: [
                  { to: 1, key: "Out of stock" },
                  { from: 1, key: "In stock" }
                ]
              }
            },
            min_price: { min: { field: "variants.price" } },
            max_price: { max: { field: "variants.price" } }
          }
        };
        aggs["ymma_fitments"] = {
          nested: {
            path: "metafields.ymma_fitment"
          },
          aggs: {
            all_values: {
              terms: { field: "metafields.ymma_fitment.value" }
            }
          }
        };
        for (const el of document.querySelectorAll('[data-filter-type="variant_option"]')) {
          const { filterOptionName } = el.dataset;
          aggs[filterOptionName] = {
            nested: {
              path: "variants.selectedOptions"
            },
            aggs: {
              all_values: {
                filter: {
                  term: { "variants.selectedOptions.name": filterOptionName }
                },
                aggs: {
                  all_possible_values: {
                    terms: { field: "variants.selectedOptions.value", size: 50 }
                  }
                }
              }
            }
          };
        }
        aggs["product_types"] = {
          terms: { field: "productType", size: 50 }
        };
        if (isSelectingYMM) {
          aggs["ymm_values"] = {
            nested: {
              path: "ymms"
            },
            aggs: {
              all_values: {
                terms: { field: `ymms.${aggOptions.nextYMMName}`, size: 1e3 }
              }
            }
          };
        }
      }
      return {
        _source: {
          exclude: ["ymms.*"]
        },
        from,
        size: aggOptions?.noResults ? 0 : size,
        query,
        aggs,
        sort
      };
    },
    renderResult: function(hits, template) {
      const resultArray = [];
      const productTemplate = template;
      if (!hits.hits.length) {
        return false;
      }
      let HTML = "";
      let results = hits.hits.map(({ _source }) => _source);
      const sortElement = document.querySelector('[name="ymm_sort"]:checked');
      if (sortElement && sortElement.value == "manual") {
        const orderArray = JSON.parse(document.getElementById("collectionSortDefault").textContent);
        results.sort((a, b) => {
          let indexOfA = orderArray.indexOf(a.handle);
          let indexOfB = orderArray.indexOf(b.handle);
          if (indexOfA === -1)
            indexOfA = orderArray.length;
          if (indexOfB === -1)
            indexOfB = orderArray.length;
          return indexOfA - indexOfB;
        });
      }
      results.forEach((item) => {
        const parse = new DOMParser();
        let html = productTemplate;
        const { title, handle, images: [image], variants, metafields } = item;
        const { reviews_rating, reviews_rating_count, boost_tagline, boost_clp_promo } = metafields;
        let priceList = variants.map((i) => i.price);
        priceList.sort((a, b) => {
          return a - b;
        });
        const price = priceList[0] || 0;
        let review = 0;
        let reviewCount = 0;
        if (reviews_rating && reviews_rating.value != "NULL") {
          reviewCount = Math.round(+reviews_rating_count.value);
          review = JSON.parse(reviews_rating.value).value;
        }
        const array = [
          {
            key: "title",
            value: title
          },
          {
            key: "handle",
            value: handle
          },
          {
            key: "image",
            value: image?.url || "https://cdn.shopify.com/s/files/1/0601/4527/0921/t/10/assets/default-image.jpg?v=1692203040"
          },
          {
            key: "imageWidth",
            value: image?.width || 900
          },
          {
            key: "imageHeight",
            value: image?.height || 900
          },
          {
            key: "price",
            value: Intl.NumberFormat("en", { style: "currency", currency: "USD" }).format(price)
          },
          {
            key: "reviewCount",
            value: reviewCount
          },
          {
            key: "review",
            value: review
          },
          {
            key: "boost_tagline",
            value: boost_tagline?.value?.replace("NULL", "") || ""
          },
          {
            key: "isFirstVariantAvailable",
            value: variants[0].availableForSale
          },
          {
            key: "soldOut",
            value: variants.some(v => v.availableForSale)
              ? ''
              : `<div style="position:relative">
                  <div class="product-meta__label-list label-list"">
                    <span class="label label--subdued" style="margin-top:10px;">SOLD OUT</span>
                  </div>
                </div>`
          },
          {
            key: "isFirstVariantId",
            value: variants[0].id
          }
        ];
        array.forEach((item2) => {
          const regex = `{{${item2.key}}}`;
          html = html.replaceAll(regex, item2.value);
        });
        const div = document.createElement("div");
        div.innerHTML = html;
        HTML += div.firstElementChild.outerHTML;
      });
      return HTML;
    }
  };

  // app/scripts/component/ymmPaginate.js
  var customElementTagName = "ymm-paginate";
  !window.customElements.get(customElementTagName) && window.customElements.define(customElementTagName, class extends HTMLElement {
    constructor() {
      super();
      this.infiniteType = this.dataset.type == "infinite";
    }
    initInfiniteLoad() {
      this.observer = new IntersectionObserver((entries, observer) => {
        entries[0].isIntersecting && !this.classList.contains("hide") && window.dispatchEvent(new CustomEvent("ymm:filter", {
          detail: {
            type: "infinite"
          }
        }));
      });
      this.observer.observe(this);
    }
    build(totalPage, active) {
      this.classList.toggle("hide", totalPage < 1);
      this.querySelector(".paginate-list").innerHTML = "";
      if (this.infiniteType) {
        const index = active + 1;
        if (totalPage < 1 || index >= totalPage) {
          this.classList.toggle("hide", true);
          return;
        }
        const button = document.createElement("button");
        button.className = "btn active jsYMMPaginateItem";
        button.setAttribute("data-page", index);
        button.textContent = this.dataset.text;
        this.querySelector(".paginate-list").appendChild(button);
        return;
      }
      if (totalPage > 5) {
        const currentPageIndex = active + 1;
        [-2, -1, 0, 1, 2].forEach((number) => {
          const index = number + currentPageIndex;
          if (index <= 0 || index >= totalPage)
            return;
          number == -2 && index - 1 > 1 && (this.querySelector(".paginate-list").innerHTML += '<span class="inline-block">...</span>');
          const button = document.createElement("button");
          button.className = "btn disabled" + (index == currentPageIndex ? " active" : "");
          button.setAttribute("data-page", active + number);
          button.textContent = index;
          this.querySelector(".paginate-list").appendChild(button);
          number == 2 && totalPage - index > 1 && (this.querySelector(".paginate-list").innerHTML += '<span class="inline-block">...</span>');
        });
      } else {
        for (var i = 0; i < totalPage; i++) {
          const button = document.createElement("button");
          button.className = "btn disabled" + (i == active ? " active" : "");
          button.setAttribute("data-page", i);
          button.textContent = i + 1;
          this.querySelector(".paginate-list").appendChild(button);
        }
      }
      this.querySelectorAll(".paginate-list button")?.forEach((button) => this.setEvent(button));
    }
    setEvent(button) {
      button.classList.add("jsYMMPaginateItem");
      button.classList.remove("disabled");
    }
  });

  // app/scripts/component/ymmFilter.js
  var customElementTagName2 = "ymm-filter-component";
  !window.customElements.get(customElementTagName2) && window.customElements.define(customElementTagName2, class extends HTMLElement {
    constructor() {
      super();
      this.setDefault();
      !this.closest("modal-content") && this.filter(true);
      this.addEventListener("change", ({ target }) => {
        const filterType = target.closest("[data-filter-type]")?.dataset?.filterType;
        filterType && this.filter(false, filterType);
      });
      document.querySelector("#sort-by-popover")?.addEventListener("change", (e) => {
        e.stopImmediatePropagation();
        this.filter(false);
      });
      document.body.addEventListener("click", (e) => {
        const { target } = e;
        if (target.closest(".jsYMMPrev") || target.closest(".jsYMMNext")) {
          e.stopImmediatePropagation();
          const ymmValue = YMM.getYMMValue();
          const lastQuery = this.lastQuery || "";
          if (lastQuery == JSON.stringify(ymmValue)) {
            this.page = target.closest(".jsYMMNext") ? this.page + 1 : this.page - 1;
          }
          (target.closest(".jsYMMPrev") || target.closest(".jsYMMNext")).toggleAttribute("disabled", true);
          this.filter(false);
        }
        if (target.closest(".jsYMMPaginateItem")) {
          e.stopImmediatePropagation();
          target.closest(".jsYMMPaginateItem").toggleAttribute("disabled", true);
          this.page = +target.closest(".jsYMMPaginateItem").dataset.page;
          this.infiniteType && (this.loadMore = true);
          this.filter(false);
        }
      });
    }
    callFilter(e) {
      if (this.isFiltering)
        return;
      if (!!(e.detail?.type == "infinite")) {
        this.page++;
        this.loadMore = true;
      }
      this.filter(false);
    }
    connectedCallback() {
      !window.ymmFilterEvent && window.addEventListener("ymm:filter", (e) => {
        this.callFilter(e);
      });
      window.ymmFilterEvent = true;
    }
    disconnectCallback() {
      window.ymmFilterEvent = null;
      window.removeEventListener("ymm:filter", (e) => {
        this.callFilter(e);
      });
    }
    setDefault() {
      this.page = 0;
      this.size = +this.dataset.size || 24;
      this.infiniteType = this.dataset.type == "infinite";
    }
    async filter(reset = false, filterType = null) {
      document.documentElement.dispatchEvent(new Event("theme:loading:start"));
      this.isFiltering = true;
      const { ymmAPI: ymmAPI2, ymmFilter: ymmFilter2, renderResult } = YMM;
      const { hits, aggregations } = await ymmAPI2(ymmFilter2(this, { include: true }));
      this.populateFilters(aggregations, reset, filterType);
      const sortElment = document.querySelector('input[name="ymm_sort"]:checked');
      document.getElementById("sort-by-selected-value").innerHTML = sortElment.nextElementSibling.innerHTML;
      const from = this.page * this.size;
      const totalPage = Math.ceil(hits.total.value / this.size);
      document.querySelector("ymm-paginate").build(totalPage, this.page);
      document.querySelector(".jsYMMPaginate .jsYMMPrev")?.classList.toggle("disabled", !from);
      document.querySelector(".jsYMMPaginate .jsYMMNext")?.classList.toggle("disabled", from + hits.hits.length >= hits.total.value);
      const resultsCount = document.querySelector(".jsYMMResultCount");
      if (resultsCount) {
        const currentItemShowing = isEmpty(hits.hits) ? 0 : hits.hits.length;

        let totalItems = currentItemShowing > 0 ? hits.total.value : 0;
        if (this.infiniteType)
          resultsCount.innerText = `Showing ${from + currentItemShowing} of ${totalItems} results`;
        else
          resultsCount.innerText = `${totalItems} results (showing ${from + 1}-${from + currentItemShowing})`;
        resultsCount.classList.toggle("hide", totalItems == 0);
      }
      const results = document.querySelector(".jsYMMResult");
      const resultItemTemplate = document.getElementById("jsYMMItem").content.firstElementChild.cloneNode(true).outerHTML;

      if (this.infiniteType) {
        if (this.loadMore) {
          results.innerHTML += renderResult.call(this, hits, resultItemTemplate);
        } else {
          results.innerHTML = (isEmpty(hits.hits) ?
            results.dataset.text :
            renderResult.call(this, hits, resultItemTemplate));
          this.page = 0;
        }
      } else {
        results.innerHTML = (isEmpty(hits.hits) ?
          results.dataset.text :
          renderResult.call(this, hits, resultItemTemplate));
      }
      results.classList.toggle("no-results", !results.childElementCount);
      results.querySelectorAll("product-item").forEach(async (product) => {
        await product.untilVisible({ threshold: product.clientHeight > 0 ? Math.min(50 / product.clientHeight, 1) : 0 });
      });
      if (document.querySelector(".jsYMMContainer"))
        document.querySelector(".jsYMMContainer").style.display = "block";
      this.querySelector("ymm-selector").updateURL();
      this.closest("popup-ymm-search")?.close();
      document.documentElement.dispatchEvent(new Event("theme:loading:end"));
      document.documentElement.dispatchEvent(new Event("ymm:filter:loaded"));
      this.isFiltering = null;
      this.loadMore = null;
    }
    populateFilters(aggs, reset = false, filterType = null) {
      if (reset || filterType === "fitment") {
        const priceRangeElement = document.querySelector('[data-filter-type="variant_price"]');
        const gte = priceRangeElement.querySelector('input[name*="gte"]');
        const lte = priceRangeElement.querySelector('input[name*="lte"]');
        const { min_price, max_price } = aggs.variants;
        const min = min_price.value;
        const max = max_price.value;
        const oldMin = gte.getAttribute("min");
        const oldMax = lte.getAttribute("max");
        priceRangeElement.querySelectorAll("input").forEach((input) => {
          if (min != null)
            input.setAttribute("min", min);
          if (max != null)
            input.setAttribute("max", max);
          if (input.classList.contains("jsRangeMin")) {
            if (min != null)
              input.placeholder = min;
            if (min != null && (reset || floatEqual(gte.value, oldMin))) {
              input.value = min;
            }
          }
          if (input.classList.contains("jsRangeMax")) {
            if (max != null)
              input.placeholder = max;
            if (max != null && (reset || floatEqual(lte.value, oldMax))) {
              input.value = max;
            }
          }
        });
      }
      populateFilter(document.querySelector('[data-filter-type="fitment"]'), ["Universal", "Vehicle Specific"].map((key) => ({ key })), null, window.ymmOptions.firstLoad && Object.keys(YMM.getYMMValue()).length);
      populateFilter(document.querySelector('[data-filter-type="product_type"]'), aggs.product_types.buckets);
      window.ymmOptions.firstLoad = false;
      for (const el of document.querySelectorAll('[data-filter-type="variant_option"]')) {
        populateFilter(el, aggs?.[el.dataset.filterOptionName]?.all_values?.all_possible_values?.buckets);
      }
      function populateFilter(el, buckets, checked = false, forceChecked = false) {
        if (el == null || buckets == null)
          return;
        const wrapper = el.querySelector(".jsYMMFilterWrapper");
        const checkedValues = /* @__PURE__ */ new Set();
        const inputs = wrapper.querySelectorAll("input");
        for (const input of inputs) {
          input.checked && checkedValues.add(input.value);
        }
        wrapper.innerHTML = "";
        el.closest(".js-filter-group").toggleAttribute("hidden", !buckets.length || false);
        for (let i = 0; i < buckets.length; i++) {
          const { key, hide } = buckets[i];
          if (key == null || String(key).trim() === "")
            continue;
          const id = `${el.dataset.filterType}-${key}-${i}`;
          const item = el.querySelector("template").content.firstElementChild.cloneNode(true);
          item.toggleAttribute("hidden", hide || false);
          const input = item.querySelector("input");
          input.value = key;
          input.id = id;
          if (checkedValues.has(key) || (inputs.length === 0 || reset) && checked || forceChecked)
            input.checked = true;
          const label = item.querySelector("label");
          label.setAttribute("for", id);
          const span = item.querySelector(".filter-label");
          span.textContent = key;
          wrapper.appendChild(item);
        }
      }
    }
  });
  !window.customElements.get("ymm-filter-section") && window.customElements.define("ymm-filter-section", class extends HTMLElement {
    constructor() {
      super();
      this.setDefault();
      this.addEventListener("change", ({ target }) => {
        const filterType = target.closest("[data-filter-type]")?.dataset?.filterType;
        filterType && this.filter(false, filterType);
      });
    }
    callFilter(e) {
      if (this.isFiltering)
        return;
      if (!!(e.detail?.type == "infinite")) {
        this.page++;
        this.loadMore = true;
      }
      this.filter(false);
    }
    connectedCallback() {
      window.addEventListener("ymm:filter", (e) => {
        this.callFilter(e);
      });
    }
    disconnectCallback() {
      window.removeEventListener("ymm:filter", (e) => {
        this.callFilter(e);
      });
    }
    setDefault() {
      this.page = 0;
      this.size = +this.dataset.size || 24;
      this.infiniteType = this.dataset.type == "infinite";
    }
    async filter(reset = false, filterType = null) {
      document.documentElement.dispatchEvent(new Event("theme:loading:start"));
      this.isFiltering = true;
      const { ymmAPI: ymmAPI2, ymmFilter: ymmFilter2, renderResult } = YMM;
      const { hits, aggregations } = await ymmAPI2(ymmFilter2(this, { include: true }));
      const from = this.page * this.size;
      const totalPage = Math.ceil(hits.total.value / this.size);
      const results = document.querySelector(".jsYMMResult");
      const resultItemTemplate = document.getElementById("jsYMMItem").content.firstElementChild.cloneNode(true).outerHTML;
      if (this.infiniteType) {
        if (this.loadMore) {
          results.innerHTML += renderResult.call(this, hits, resultItemTemplate);
        } else {
          results.innerHTML = renderResult.call(this, hits, resultItemTemplate) || results.dataset.text;
          this.page = 0;
        }
      } else {
        results.innerHTML = renderResult.call(this, hits, resultItemTemplate) || results.dataset.text;
      }
      results.classList.toggle("no-results", !results.childElementCount);
      results.querySelectorAll("product-item").forEach(async (product) => {
        await product.untilVisible({ threshold: product.clientHeight > 0 ? Math.min(50 / product.clientHeight, 1) : 0 });
      });
      if (document.querySelector(".jsYMMContainer"))
        document.querySelector(".jsYMMContainer").style.display = "block";
      this.querySelector("ymm-selector").updateURL();
      document.documentElement.dispatchEvent(new Event("theme:loading:end"));
      document.documentElement.dispatchEvent(new Event("ymm:filter:loaded"));
      this.closest(".shopify-section").toggleAttribute("hidden", true);
      this.isFiltering = null;
      this.loadMore = null;
    }
  });

  // app/scripts/component/productSwatches.js
  var productSwatches = class extends HTMLElement {
    constructor() {
      super();
      this.productItem = this.closest("product-item");
      this.insertTarget = this.productItem.querySelector(".jsSwatchImageHolder");
      this.swatchEls = document.createElement("div");
      this.swatchEls.innerHTML = this.insertTarget.textContent;
      this.querySelectorAll(".swatch-input").forEach((item) => {
        item.addEventListener("change", () => {
          const value = item.value;
          const swatchImg = Array.from(this.swatchEls.querySelectorAll(".image-swatch")).find((item2) => {
            return item2.dataset.value == value;
          });
          this.productItem.querySelectorAll(".image-swatch").forEach((item2) => item2.remove());
          if (!swatchImg)
            return;
          const newElm = swatchImg.cloneNode(true);
          newElm.classList.add("active");
          this.insertTarget.insertAdjacentElement("afterend", newElm);
        });
      });
    }
  };
  customElements.define("product-swatch", productSwatches);

  // app/scripts/component/reviewCounter.js
  customElements.define("review-counter", class extends HTMLElement {
    connectedCallback() {
      this.style.display = "none";
      const observerOptions = {
        childList: true,
        attributes: true,
        subtree: true
      };
      this.observer = new MutationObserver(this.callback.bind(this));
      this.observer.observe(this, observerOptions);
    }
    callback(mutationList, observer) {
      mutationList.forEach((mutation) => {
        switch (mutation.type) {
          case "childList":
            const target = this.querySelector("[data-count]");
            if (target) {
              this.render(target);
              this.observer.disconnect();
            }
            break;
          case "attributes":
            break;
        }
      });
    }
    render(target) {
      document.querySelectorAll(this.tagName).forEach((item) => {
        item.innerHTML = target.dataset.count + " " + item.dataset.msg;
        item.style.display = null;
      });
    }
  });

  // app/scripts/theme-custom.js
  document.addEventListener("DOMContentLoaded", () => {
    document.addEventListener("click", (e) => {
      const target = e.target;
      if (target.closest("a") && target.closest("a").href.includes("#ymm")) {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth"
        });
        document.querySelector("#shopify-section-header ymm-selector").open = true;
      }
    });
  });
})();